import { databasePasswordAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { postgresConnectionFields, postgresConnectionString } from "./shared";

export const postgres = defineConnector({
  identifier: "postgres",
  name: "Postgres",
  tagLine: "Relational database",
  keywords: "postgresql psql pgsql sql relational rdbms database",
  logo,
  tags: ["data"],
  protocol: "postgres",
  connectionTest: {
    protocol: "postgres",
    connectionString: postgresConnectionString,
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: (app) => databasePasswordAuth(app.secret.password),
  steps: [
    {
      title: "Enter your Postgres connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "Postgres",
          target: { kind: "connectedApp", field: "name" },
        },
        ...postgresConnectionFields,
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "select",
          label: "TLS",
          required: true,
          defaultValue: "false",
          target: { kind: "configuration", field: "tls" },
          options: [
            { value: "false", label: "Disabled" },
            { value: "true", label: "Enabled" },
          ],
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for private or self-signed Postgres servers.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
          visibleWhen: {
            target: { kind: "configuration", field: "tls" },
            value: "true",
          },
        },
      ],
    },
  ],
  publicEnvVars: (configuration) => ({
    POSTGRES_URL: postgresConnectionString(configuration),
  }),
  usageHint: () =>
    "Use process.env.POSTGRES_URL as the Postgres connection string.",
});
